var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { computed, set } from '@ember/object';
import { alias } from '@ember/object/computed';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import TrackRelationships from 'ember-data-relationship-tracker';
import { PricingType } from '@square/dashboard-items-data/models/connect/item-variation/data';
import Money from '@square/dashboard-money/models/money';
import { getOwner } from '@ember/application';
import { inject as service } from '@ember/service';
import { A } from '@ember/array';
import { isNone } from '@ember/utils';
let ItemVariation = (_dec = service(), _dec2 = attr('string', {
  protoEnum: CatalogObjectTypeProto,
  defaultValue: CatalogObjectType.ITEM_VARIATION
}), _dec3 = belongsTo('connect/item', {
  async: false
}), _dec4 = fragment('connect/item-variation/data'), _dec5 = fragmentArray('intermission'), _dec6 = hasMany('connect/image', {
  async: false
}), _dec7 = hasMany('connect/item-variation-vendor-info', {
  async: false
}), _dec8 = alias('itemVariationData.name'), _dec9 = alias('itemVariationData.ordinal'), _dec10 = alias('itemVariationData.pricingType'), _dec11 = alias('itemVariationData.priceMoney'), _dec12 = alias('itemVariationData.trackInventory'), _dec13 = alias('itemVariationData.inventoryAlertType'), _dec14 = alias('itemVariationData.inventoryAlertThreshold'), _dec15 = alias('itemVariationData.buyerFacingName'), _dec16 = alias('itemVariationData.userData'), _dec17 = alias('itemVariationData.locationOverrides'), _dec18 = alias('itemVariationData.sku'), _dec19 = alias('itemVariationData.upc'), _dec20 = alias('itemVariationData.serviceDuration'), _dec21 = alias('itemVariationData.priceDescription'), _dec22 = alias('itemVariationData.availableForBooking'), _dec23 = alias('itemVariationData.noShowFee'), _dec24 = alias('itemVariationData.noShowFeePercentage'), _dec25 = alias('itemVariationData.serviceCostFlat'), _dec26 = alias('itemVariationData.hasValidServiceCostFlat'), _dec27 = alias('itemVariationData.serviceCostPercentage'), _dec28 = alias('itemVariationData.hasValidServiceCostPercentage'), _dec29 = alias('itemVariationData.transitionTime'), _dec30 = alias('itemVariationData.sellable'), _dec31 = alias('itemVariationData.stockable'), _dec32 = alias('itemVariationData.isVariablePriced'), _dec33 = alias('itemVariationData.kitchenName'), _dec34 = alias('itemVariationData.contractTemplateToken'), _dec35 = alias('itemVariationData.defaultUnitCost'), _dec36 = alias('itemVariationData.stockableConversion'), _dec37 = alias('itemVariationData.weight'), _dec38 = alias('itemVariationData.channels'), _dec39 = hasMany('connect/item-variation/sale-price', {
  async: false
}), _dec40 = computed('salePrices.firstObject'), _dec41 = computed('stockable', function () {
  return isNone(this.stockable) || this.stockable;
}), _dec42 = alias('itemVariationData.subscriptionPlanIds'), _dec43 = alias('version'), _dec44 = computed('_defaultVendorInfo', 'itemVariationVendorInfos.@each.ordinal'), (_class = (_class2 = class ItemVariation extends CatalogObject.extend(TrackRelationships) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "type", _descriptor2, this);
    // @ts-expect-error WIP
    _initializerDefineProperty(this, "item", _descriptor3, this);
    _initializerDefineProperty(this, "itemVariationData", _descriptor4, this);
    _initializerDefineProperty(this, "intermissions", _descriptor5, this);
    _initializerDefineProperty(this, "images", _descriptor6, this);
    _initializerDefineProperty(this, "itemVariationVendorInfos", _descriptor7, this);
    _initializerDefineProperty(this, "name", _descriptor8, this);
    _initializerDefineProperty(this, "ordinal", _descriptor9, this);
    _initializerDefineProperty(this, "pricingType", _descriptor10, this);
    _initializerDefineProperty(this, "priceMoney", _descriptor11, this);
    _initializerDefineProperty(this, "trackInventory", _descriptor12, this);
    _initializerDefineProperty(this, "inventoryAlertType", _descriptor13, this);
    _initializerDefineProperty(this, "inventoryAlertThreshold", _descriptor14, this);
    _initializerDefineProperty(this, "buyerFacingName", _descriptor15, this);
    _initializerDefineProperty(this, "userData", _descriptor16, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor17, this);
    _initializerDefineProperty(this, "sku", _descriptor18, this);
    _initializerDefineProperty(this, "upc", _descriptor19, this);
    _initializerDefineProperty(this, "serviceDuration", _descriptor20, this);
    _initializerDefineProperty(this, "priceDescription", _descriptor21, this);
    _initializerDefineProperty(this, "availableForBooking", _descriptor22, this);
    _initializerDefineProperty(this, "noShowFee", _descriptor23, this);
    _initializerDefineProperty(this, "noShowFeePercentage", _descriptor24, this);
    _initializerDefineProperty(this, "serviceCostFlat", _descriptor25, this);
    _initializerDefineProperty(this, "hasValidServiceCostFlat", _descriptor26, this);
    _initializerDefineProperty(this, "serviceCostPercentage", _descriptor27, this);
    _initializerDefineProperty(this, "hasValidServiceCostPercentage", _descriptor28, this);
    _initializerDefineProperty(this, "transitionTime", _descriptor29, this);
    _initializerDefineProperty(this, "sellable", _descriptor30, this);
    _initializerDefineProperty(this, "stockable", _descriptor31, this);
    _initializerDefineProperty(this, "isVariablePriced", _descriptor32, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor33, this);
    _initializerDefineProperty(this, "contractTemplateToken", _descriptor34, this);
    _initializerDefineProperty(this, "defaultUnitCost", _descriptor35, this);
    _initializerDefineProperty(this, "stockableConversion", _descriptor36, this);
    _initializerDefineProperty(this, "weight", _descriptor37, this);
    _initializerDefineProperty(this, "channels", _descriptor38, this);
    _initializerDefineProperty(this, "salePrices", _descriptor39, this);
    // For legacy purposes, undefined stockable attribute is considered true
    _initializerDefineProperty(this, "isStockable", _descriptor40, this);
    _initializerDefineProperty(this, "subscriptionPlanIds", _descriptor41, this);
    // Needed by ember-data-relationship-tracker to track relationships like images
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor42, this);
  }
  static createDefault(store, itemId, presentAtAllLocations = true, presentAtLocationIds = A([]), absentAtLocationIds = A([])) {
    const variation = store.createRecord('connect/item-variation', {
      itemVariationData: store.createFragment('connect/item-variation/data', {
        itemId
      }),
      absentAtLocationIds,
      presentAtLocationIds,
      presentAtAllLocations
    });
    return variation;
  }
  get effectiveSalePrice() {
    return this.salePrices.firstObject;
  }
  get defaultVendorInfo() {
    if (this._defaultVendorInfo !== undefined) {
      return this._defaultVendorInfo;
    }
    return this.itemVariationVendorInfos.sortBy('ordinal')?.[0];
  }
  set defaultVendorInfo(value) {
    set(this, '_defaultVendorInfo', value);
  }
  get measurementUnit() {
    if (this.itemVariationData.measurementUnitId) {
      return this.store.peekRecord('connect/measurement-unit', this.itemVariationData.measurementUnitId);
    }
    return null;
  }
  getLocationOverride(unitToken) {
    return this.locationOverrides?.find(locationOverride => locationOverride.locationId === unitToken);
  }
  static createDefaultForDonation(store, presentAtAllLocations = true, presentAtLocationIds = A([]), absentAtLocationIds = A([])) {
    const application = getOwner(store);
    const intl = application.lookup('service:intl');
    const defaultDonationAmounts = [{
      name: Money.fromCents(1000).formatted,
      price: Money.fromCents(1000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 0
    }, {
      name: Money.fromCents(2000).formatted,
      price: Money.fromCents(2000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 1
    }, {
      name: Money.fromCents(5000).formatted,
      price: Money.fromCents(5000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 2
    }, {
      name: Money.fromCents(10000).formatted,
      price: Money.fromCents(10000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 3
    }, {
      name: intl.t('items.itemLibrary.edit.donationDetails.customAmount'),
      pricingType: PricingType.VARIABLE_PRICING,
      ordinal: 4
    }];
    const donationVariations = defaultDonationAmounts.map(donation => {
      const priceFragment = store.createFragment('price-money', {
        amount: donation.price?.amount ?? null,
        currency: donation.price?.currencyCode ?? 'USD'
      });
      const itemVariationOverrides = {
        name: donation.name,
        pricingType: donation.pricingType,
        ordinal: donation.ordinal
      };
      if (donation.pricingType === PricingType.FIXED_PRICING) {
        itemVariationOverrides.priceMoney = priceFragment;
      }
      const itemVariationData = store.createFragment('connect/item-variation/data', itemVariationOverrides);
      const variation = store.createRecord('connect/item-variation', {
        itemVariationData
      });
      return variation;
    });
    donationVariations.forEach(variation => {
      variation.presentAtAllLocations = presentAtAllLocations;
      variation.presentAtLocationIds = presentAtLocationIds;
      variation.absentAtLocationIds = absentAtLocationIds;
    });
    return donationVariations;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/item-variation'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "item", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "itemVariationData", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intermissions", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "images", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "itemVariationVendorInfos", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "pricingType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "priceMoney", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "trackInventory", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "inventoryAlertType", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "inventoryAlertThreshold", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "buyerFacingName", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "userData", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "locationOverrides", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "sku", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "upc", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "serviceDuration", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "priceDescription", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "availableForBooking", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "noShowFee", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "noShowFeePercentage", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "serviceCostFlat", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "hasValidServiceCostFlat", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "serviceCostPercentage", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "hasValidServiceCostPercentage", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "transitionTime", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "sellable", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "stockable", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "isVariablePriced", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "kitchenName", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "contractTemplateToken", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "defaultUnitCost", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "stockableConversion", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "weight", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "salePrices", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "effectiveSalePrice", [_dec40], Object.getOwnPropertyDescriptor(_class.prototype, "effectiveSalePrice"), _class.prototype), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "isStockable", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanIds", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "relationshipTrackerVersion", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "defaultVendorInfo", [_dec44], Object.getOwnPropertyDescriptor(_class.prototype, "defaultVendorInfo"), _class.prototype)), _class));
export { ItemVariation as default };